import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  fetchDomainPromo,
  fetchExtensionRegister,
  fetchExtensionTransfer,
  fetchGetStatus,
  fetchPriceRenew,
  fetchRegistrar,
  fetchSearch,
} from "./domainsAPI";

export const searchDomainName = createAsyncThunk(
  "domain/search",
  async (domainName) => {
    let tld = domainName.split(".");
    let tldString;
    if (tld.length > 2) {
      tldString = "." + tld[1] + "." + tld[2];
    } else {
      tldString = "." + tld[1];
    }
    const response1 = await fetchSearch(domainName);
    const response2 = await fetchPriceRenew(tldString);
    const response3 = await fetchRegistrar(tldString);

    let response = { response1, response2, response3 };

    return response;
  }
);

export const queryDomainTransfer = createAsyncThunk(
  "domain/transfer/search",
  async (domainName) => {
    let tld = domainName.split(".");
    let tldString;
    if (tld.length > 2) {
      tldString = "." + tld[1] + "." + tld[2];
    } else {
      tldString = "." + tld[1];
    }

    const response1 = await fetchSearch(domainName);
    const response2 = await fetchPriceRenew(tldString);
    const response3 = await fetchExtensionTransfer(tldString);

    let response = { response1, response2, response3 };

    return response;
  }
);

export const searchDomains = createAsyncThunk(
  "domain/find",
  async (domainArr) => {
    let arr_response = [];

    for (const domain of domainArr) {
      let tld = domain.split(".");
      let tldString;
      if (tld.length > 2) {
        tldString = "." + tld[1] + "." + tld[2];
      } else {
        tldString = "." + tld[1];
      }

      const response1 = await fetchSearch(domain);
      const response2 = await fetchExtensionRegister(tldString);
      const response3 = await fetchPriceRenew(tldString);
      const response4 = await fetchRegistrar(tldString);

      arr_response.push({ response1, response2, response3, response4 });
    }

    return arr_response;
  }
);

export const searchDomainsPromo = createAsyncThunk(
  "domain_promo/find",
  async (data) => {
    let arr_response = [];

    for (const domain of data.domains) {
      let tld = domain.split(".");
      let tldString;
      if (tld.length > 2) {
        tldString = "." + tld[1] + "." + tld[2];
      } else {
        tldString = "." + tld[1];
      }

      const response1 = await fetchSearch(domain);
      const response2 = await fetchExtensionRegister(tldString);
      const response3 = await fetchPriceRenew(tldString);
      const response4 = await fetchRegistrar(tldString);
      let response5 = "";
      let promocode = "";
      if (tldString === ".id") {
        const payload = {
          promo_code: data.promocode ? data.promocode : "",
          pid: "",
          extensions: ".id",
          cycles: "",
          periods: "1Years",
          productname: "",
        };
        response5 = await fetchDomainPromo(payload);
        promocode = data.promocode;
      }

      arr_response.push({
        response1,
        response2,
        response3,
        response4,
        response5,
        promocode,
      });
    }

    return arr_response;
  }
);

export const getStatusDomain = createAsyncThunk(
  "domainBackorder/getStatus",
  async (domainName) => {
    let tld = domainName.split(".");
    let tldString;
    if (tld.length > 2) {
      tldString = "." + tld[1] + "." + tld[2];
    } else {
      tldString = "." + tld[1];
    }
    const response1 = await fetchGetStatus(domainName);
    const response2 = await fetchExtensionRegister(tldString);
    const response3 = await fetchPriceRenew(tldString);
    const domain = domainName;
    let response = { response1, response2, response3, domain };

    return response;
  }
);

const domainSlice = createSlice({
  name: "domain",
  initialState: {
    status: "",
    error: "",
    domain_register: [],
    domain_transfer: [],
    premium_price: 0,
    premium_status: false,
    nameservers: "",
    backorder_status: "",
    freeWhois: false,
  },
  reducers: {
    search: (state, action) => {
      const formatPrice = action.payload.price.replace(/\./g, "");
      if (action.payload.domain.length === 2) {
        if (action.payload.extension === ".id") {
          const price = 525000000;
          return {
            ...state,
            domain_register: [
              {
                domain: action.payload.domain + action.payload.extension,
                price: parseInt(formatPrice),
                duration: 1,
                type: "register",
              },
            ],
            premium_price: price,
            premium_status: true,
          };
        } else if (
          action.payload.extension === ".co.id" ||
          action.payload.extension === ".web.id" ||
          action.payload.extension === ".ac.id" ||
          action.payload.extension === ".my.id" ||
          action.payload.extension === ".biz.id" ||
          action.payload.extension === ".or.id" ||
          action.payload.extension === ".ponpes.id" ||
          action.payload.extension === ".sch.id"
        ) {
          const price = 16500000;
          return {
            ...state,
            domain_register: [
              {
                domain: action.payload.domain + action.payload.extension,
                price: parseInt(formatPrice),
                duration: 1,
                type: "register",
              },
            ],
            premium_price: price,
            premium_status: true,
          };
        } else {
          const formatPrice = action.payload.price.replace(/\./g, "");
          return {
            ...state,
            domain_register: [
              {
                domain: action.payload.domain + action.payload.extension,
                price: formatPrice,
                duration: action.payload.extension === ".ai" ? 2 : 1,
                type: "register",
              },
            ],
            premium_price: 0,
            premium_status: false,
          };
        }
      } else if (
        action.payload.domain.length === 3 &&
        action.payload.extension === ".id"
      ) {
        const price = 16500000;
        return {
          ...state,
          domain_register: [
            {
              domain: action.payload.domain + action.payload.extension,
              price: parseInt(formatPrice),
              duration: 1,
              type: "register",
            },
          ],
          premium_price: price,
          premium_status: true,
        };
      } else if (
        action.payload.domain.length === 4 &&
        action.payload.extension === ".id"
      ) {
        const price = 2250000;
        return {
          ...state,
          domain_register: [
            {
              domain: action.payload.domain + action.payload.extension,
              price: parseInt(formatPrice),
              duration: 1,
              type: "register",
            },
          ],
          premium_price: price,
          premium_status: true,
        };
      } else {
        return {
          ...state,
          domain_register: [
            {
              domain: action.payload.domain + action.payload.extension,
              price: formatPrice,
              duration: action.payload.extension === ".ai" ? 2 : 1,
              type: "register",
            },
          ],
          premium_price: 0,
          premium_status: false,
        };
      }
    },
    searchTransfer: (state, action) => {
      const formatPrice = action.payload.price.replace(/\./g, "");
      return {
        ...state,
        domain_transfer: [
          {
            domain: action.payload.domain + action.payload.extension,
            price: formatPrice,
            duration: 1,
            type: "transfer",
          },
        ],
      };
    },
    addEpp: (state, action) => {
      state.domain_transfer = state.domain_transfer.map((obj) => {
        if (obj.domain === action.payload.domain) {
          obj.epp = action.payload.epp;
        }
        return obj;
      });
    },
    handleCLickCheckbox: (state, action) => {
      state.domain_register = state.domain_register.map((obj) => {
        if (obj.domain === action.payload[0] && action.payload[1] === true) {
          obj.state_whois = true;
          obj.domainWhois = action.payload[0];
        } else if (
          obj.domain === action.payload[0] &&
          action.payload[1] === false
        ) {
          obj.state_whois = false;
        }

        return obj;
      });
    },
    handleSelectDuration: (state, action) => {
      state.domain_register = state.domain_register.map((obj) => {
        if (obj.domain === action.payload[0]) {
          obj.duration = action.payload[1];
        }
        return obj;
      });
    },
    saveNameservers: (state, action) => {
      state.nameservers = action.payload;
    },
    backorderStatus: (state, action) => {
      state.backorder_status = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchDomainName.pending, (state) => {
        state.status = "loading";
      })
      .addCase(searchDomainName.fulfilled, (state, action) => {
        state.status = "fulfilled";
        const response1 = action.payload.response1.datas;
        const response2 = action.payload.response2;
        const response3 = action.payload.response3.data;
        const priceRenew = response2.data[0].msetupfee.split(".");

        // Hardcode is_premium menjadi 0
        // response1.data.result.is_premium = 0;

        if (
          state.domain_register.find(
            (register) => register.domain === response1.data.search
          )
        ) {
          if (
            response1.data.result.is_premium === 1 &&
            (response1.data.result.tld !== "co.id" ||
              response1.data.result.tld !== "web.id" ||
              response1.data.result.tld !== "ac.id" ||
              response1.data.result.tld !== "my.id" ||
              response1.data.result.tld !== "biz.id" ||
              response1.data.result.tld !== "or.id" ||
              response1.data.result.tld !== "ponpes.id" ||
              response1.data.result.tld !== "sch.id" ||
              response1.data.result.tld !== "id")
          ) {
            state.domain_register = state.domain_register.map((obj) => {
              return {
                ...obj,
                status: response1.data.result.domainStatus,
                price: response1.data.result.price_qw,
                priceRenew: priceRenew[0],
                freeWhois: false,
              };
            });
            state.premium_status = true;
          } else {
            if (response3.autoreg === "irsfanew") {
              state.freeWhois = true;
              state.domain_register = state.domain_register.map((obj) => {
                return {
                  ...obj,
                  status: response1.data.result.domainStatus,
                  priceRenew:
                    response1.data.result.tld === "ai"
                      ? response2.data[0].qsetupfee.split(".")[0]
                      : priceRenew[0],
                  freeWhois: true,
                };
              });
            } else {
              state.domain_register = state.domain_register.map((obj) => {
                return {
                  ...obj,
                  status: response1.data.result.domainStatus,
                  priceRenew:
                    response1.data.result.tld === "ai"
                      ? response2.data[0].qsetupfee.split(".")[0]
                      : priceRenew[0],
                  freeWhois: false,
                };
              });
            }
          }
        } else if (
          state.domain_transfer.find(
            (transfer) => transfer.domain === response1.data.search
          )
        ) {
          if (response3.autoreg === "irsfanew") {
            state.freeWhois = true;
            state.domain_transfer = state.domain_transfer.map((obj) => {
              return {
                ...obj,
                status: response1.data.result.domainStatus,
                priceRenew: priceRenew[0],
                whois: action.payload.response1.whois,
                freeWhois: true,
              };
            });
          } else {
            state.domain_transfer = state.domain_transfer.map((obj) => {
              return {
                ...obj,
                status: response1.data.result.domainStatus,
                priceRenew: priceRenew[0],
                whois: action.payload.response1.whois,
                freeWhois: false,
              };
            });
          }
        }
      })
      .addCase(searchDomainName.rejected, (state, action) => {
        state.status = "error";
        state.error = action.error.message;
      })
      .addCase(queryDomainTransfer.pending, (state) => {
        state.status = "loading";
      })
      .addCase(queryDomainTransfer.fulfilled, (state, action) => {
        state.status = "fulfilled";
        const response1 = action.payload.response1.datas;
        const response2 = action.payload.response2;
        const response3 = action.payload.response3;
        
        // Handle case when response doesn't have complete information
        if (!response1 || !response1.data || !response1.data.result) {
          state.domain_transfer = [
            {
              domain: action.payload.response1?.search || "Unknown",
              duration: 1,
              type: "transfer",
              price: 0,
              status: null, // Set status to null for incomplete information
              whois: action.payload.response1?.whois || "",
              priceRenew: 0,
            },
          ];
          return;
        }
        
        const priceRenew = response2.data[0].msetupfee.split(".");
        state.domain_transfer = [
          {
            domain: response1.data.search,
            duration: 1,
            type: "transfer",
            price: response3.data[0].msetupfee,
            status: response1.data.result.domainStatus,
            whois: action.payload.response1.whois,
            priceRenew: priceRenew[0],
          },
        ];
      })
      .addCase(queryDomainTransfer.rejected, (state, action) => {
        state.status = "error";
        state.error = action.error.message;
      })
      .addCase(searchDomains.pending, (state) => {
        state.status = "loading";
      })
      .addCase(searchDomains.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.domain_register = action.payload.map((obj) => {
          // Hardcode is_premium menjadi 0
          // obj.response1.datas.data.result.is_premium = 0;

          const domain = obj.response1.datas.data.result.domainName.split(".");
          const price = obj.response2.data[0].msetupfee;
          const priceRenew = obj.response3.data[0].msetupfee;
          const response4 = obj.response4.data;
          if (domain[0].length === 2) {
            if (obj.response1.datas.data.result.tld === "id") {
              state.premium_price = 525000000;
              state.premium_status = true;
              return {
                domain: obj.response1.datas.data.result.domainName,
                status: obj.response1.datas.data.result.domainStatus,
                price: price,
                priceRenew: priceRenew,
                duration: 1,
              };
            } else if (
              obj.response1.datas.data.result.tld === "co.id" ||
              obj.response1.datas.data.result.tld === "web.id" ||
              obj.response1.datas.data.result.tld === "ac.id" ||
              obj.response1.datas.data.result.tld === "my.id" ||
              obj.response1.datas.data.result.tld === "biz.id" ||
              obj.response1.datas.data.result.tld === "or.id" ||
              obj.response1.datas.data.result.tld === "ponpes.id" ||
              obj.response1.datas.data.result.tld === "sch.id"
            ) {
              state.premium_price = 16500000;
              state.premium_status = true;
              return {
                domain: obj.response1.datas.data.result.domainName,
                status: obj.response1.datas.data.result.domainStatus,
                price: price,
                priceRenew: priceRenew,
                duration: 1,
              };
            } else {
              if (response4.autoreg === "irsfanew") {
                state.freeWhois = true;
                state.premium_price = 0;
                state.premium_status = false;
                return {
                  domain: obj.response1.datas.data.result.domainName,
                  status: obj.response1.datas.data.result.domainStatus,
                  price: price,
                  priceRenew: priceRenew,
                  duration: 1,
                  freeWhois: true,
                };
              } else {
                state.premium_price = 0;
                state.premium_status = false;
                return {
                  domain: obj.response1.datas.data.result.domainName,
                  status: obj.response1.datas.data.result.domainStatus,
                  price: price,
                  priceRenew: priceRenew,
                  duration: 1,
                  freeWhois: false,
                };
              }
            }
          } else if (
            domain[0].length === 3 &&
            obj.response1.datas.data.result.tld === "id"
          ) {
            state.premium_price = 16500000;
            state.premium_status = true;
            return {
              domain: obj.response1.datas.data.result.domainName,
              status: obj.response1.datas.data.result.domainStatus,
              price: price,
              priceRenew: priceRenew,
              duration: 1,
            };
          } else if (
            domain[0].length === 4 &&
            obj.response1.datas.data.result.tld === "id"
          ) {
            state.premium_price = 2250000;
            state.premium_status = true;
            return {
              domain: obj.response1.datas.data.result.domainName,
              status: obj.response1.datas.data.result.domainStatus,
              price: price,
              priceRenew: priceRenew,
              duration: 1,
            };
          } else if (obj.response1.datas.data.result.is_premium === 1) {
            state.premium_price = 0;
            state.premium_status = true;
            return {
              domain: obj.response1.datas.data.result.domainName,
              status: obj.response1.datas.data.result.domainStatus,
              price: obj.response1.datas.data.result.price_qw,
              priceRenew: obj.response1.datas.data.result.price_qw,
              duration: 1,
            };
          } else {
            if (response4.autoreg === "irsfanew") {
              state.freeWhois = true;
              state.premium_price = 0;
              state.premium_status = false;
              return {
                domain: obj.response1.datas.data.result.domainName,
                status: obj.response1.datas.data.result.domainStatus,
                price:
                  obj.response1.datas.data.result.tld === "ai"
                    ? obj.response2.data[0].qsetupfee
                    : price,
                priceRenew:
                  obj.response1.datas.data.result.tld === "ai"
                    ? obj.response3.data[0].qsetupfee
                    : priceRenew,
                duration:
                  obj.response1.datas.data.result.tld === "ai" ? 2 : 1,
                freeWhois: true,
              };
            } else {
              state.premium_price = 0;
              state.premium_status = false;
              return {
                domain: obj.response1.datas.data.result.domainName,
                status: obj.response1.datas.data.result.domainStatus,
                price:
                  obj.response1.datas.data.result.tld === "ai"
                    ? obj.response2.data[0].qsetupfee
                    : price,
                priceRenew:
                  obj.response1.datas.data.result.tld === "ai"
                    ? obj.response3.data[0].qsetupfee
                    : priceRenew,
                duration:
                  obj.response1.datas.data.result.tld === "ai" ? 2 : 1,
                freeWhois: false,
              };
            }
          }
        });
      })
      .addCase(searchDomains.rejected, (state, action) => {
        state.status = "error";
        state.error = action.error.message;
      })
      .addCase(searchDomainsPromo.pending, (state) => {
        state.status = "loading";
      })
      .addCase(searchDomainsPromo.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.domain_register = action.payload.map((obj) => {
          // Hardcode is_premium menjadi 0
          // obj.response1.datas.data.result.is_premium = 0;

          const domain = obj.response1.datas.data.result.domainName.split(".");
          const price = obj.response2.data[0].msetupfee;
          const priceRenew = obj.response3.data[0].msetupfee;
          const response4 = obj.response4.data;

          if (obj.response5.code !== 200) {
            if (domain[0].length === 2) {
              if (obj.response1.datas.data.result.tld === "id") {
                state.premium_price = 525000000;
                state.premium_status = true;
                return {
                  domain: obj.response1.datas.data.result.domainName,
                  status: obj.response1.datas.data.result.domainStatus,
                  price: price,
                  priceRenew: priceRenew,
                  duration: 1,
                };
              } else if (
                obj.response1.datas.data.result.tld === "co.id" ||
                obj.response1.datas.data.result.tld === "web.id" ||
                obj.response1.datas.data.result.tld === "ac.id" ||
                obj.response1.datas.data.result.tld === "my.id" ||
                obj.response1.datas.data.result.tld === "biz.id" ||
                obj.response1.datas.data.result.tld === "or.id" ||
                obj.response1.datas.data.result.tld === "ponpes.id" ||
                obj.response1.datas.data.result.tld === "sch.id"
              ) {
                state.premium_price = 16500000;
                state.premium_status = true;
                return {
                  domain: obj.response1.datas.data.result.domainName,
                  status: obj.response1.datas.data.result.domainStatus,
                  price: price,
                  priceRenew: priceRenew,
                  duration: 1,
                };
              } else {
                if (response4.autoreg === "irsfanew") {
                  state.freeWhois = true;
                  state.premium_price = 0;
                  state.premium_status = false;
                  return {
                    domain: obj.response1.datas.data.result.domainName,
                    status: obj.response1.datas.data.result.domainStatus,
                    price: price,
                    priceRenew: priceRenew,
                    duration: 1,
                    freeWhois: true,
                  };
                } else {
                  state.premium_price = 0;
                  state.premium_status = false;
                  return {
                    domain: obj.response1.datas.data.result.domainName,
                    status: obj.response1.datas.data.result.domainStatus,
                    price: price,
                    priceRenew: priceRenew,
                    duration: 1,
                    freeWhois: false,
                  };
                }
              }
            } else if (
              domain[0].length === 3 &&
              obj.response1.datas.data.result.tld === "id"
            ) {
              state.premium_price = 16500000;
              state.premium_status = true;
              return {
                domain: obj.response1.datas.data.result.domainName,
                status: obj.response1.datas.data.result.domainStatus,
                price: price,
                priceRenew: priceRenew,
                duration: 1,
              };
            } else if (
              domain[0].length === 4 &&
              obj.response1.datas.data.result.tld === "id"
            ) {
              state.premium_price = 2250000;
              state.premium_status = true;
              return {
                domain: obj.response1.datas.data.result.domainName,
                status: obj.response1.datas.data.result.domainStatus,
                price: price,
                priceRenew: priceRenew,
                duration: 1,
              };
            } else if (obj.response1.datas.data.result.is_premium === 1) {
              state.premium_price = 0;
              state.premium_status = true;
              return {
                domain: obj.response1.datas.data.result.domainName,
                status: obj.response1.datas.data.result.domainStatus,
                price: obj.response1.datas.data.result.price_qw,
                priceRenew: obj.response1.datas.data.result.price_qw,
                duration: 1,
              };
            } else {
              if (response4.autoreg === "irsfanew") {
                state.freeWhois = true;
                state.premium_price = 0;
                state.premium_status = false;
                return {
                  domain: obj.response1.datas.data.result.domainName,
                  status: obj.response1.datas.data.result.domainStatus,
                  price:
                    obj.response1.datas.data.result.tld === "ai"
                      ? obj.response2.data[0].qsetupfee
                      : price,
                  priceRenew:
                    obj.response1.datas.data.result.tld === "ai"
                      ? obj.response3.data[0].qsetupfee
                      : priceRenew,
                  duration:
                    obj.response1.datas.data.result.tld === "ai" ? 2 : 1,
                  freeWhois: true,
                };
              } else {
                state.premium_price = 0;
                state.premium_status = false;
                return {
                  domain: obj.response1.datas.data.result.domainName,
                  status: obj.response1.datas.data.result.domainStatus,
                  price:
                    obj.response1.datas.data.result.tld === "ai"
                      ? obj.response2.data[0].qsetupfee
                      : price,
                  priceRenew:
                    obj.response1.datas.data.result.tld === "ai"
                      ? obj.response3.data[0].qsetupfee
                      : priceRenew,
                  duration:
                    obj.response1.datas.data.result.tld === "ai" ? 2 : 1,
                  freeWhois: false,
                };
              }
            }
          } else {
            const promo_price = obj.response5.data;
            if (domain[0].length === 2) {
              if (obj.response1.datas.data.result.tld === "id") {
                state.premium_price = 525000000;
                state.premium_status = true;
                return {
                  domain: obj.response1.datas.data.result.domainName,
                  status: obj.response1.datas.data.result.domainStatus,
                  price: price,
                  priceRenew: priceRenew,
                  duration: 1,
                };
              } else if (
                obj.response1.datas.data.result.tld === "co.id" ||
                obj.response1.datas.data.result.tld === "web.id" ||
                obj.response1.datas.data.result.tld === "ac.id" ||
                obj.response1.datas.data.result.tld === "my.id" ||
                obj.response1.datas.data.result.tld === "biz.id" ||
                obj.response1.datas.data.result.tld === "or.id" ||
                obj.response1.datas.data.result.tld === "ponpes.id" ||
                obj.response1.datas.data.result.tld === "sch.id"
              ) {
                state.premium_price = 16500000;
                state.premium_status = true;
                return {
                  domain: obj.response1.datas.data.result.domainName,
                  status: obj.response1.datas.data.result.domainStatus,
                  price: price,
                  priceRenew: priceRenew,
                  duration: 1,
                };
              } else {
                if (response4.autoreg === "irsfanew") {
                  state.freeWhois = true;
                  state.premium_price = 0;
                  state.premium_status = false;
                  return {
                    domain: obj.response1.datas.data.result.domainName,
                    status: obj.response1.datas.data.result.domainStatus,
                    price: price,
                    priceRenew: priceRenew,
                    duration: 1,
                    freeWhois: true,
                  };
                } else {
                  state.premium_price = 0;
                  state.premium_status = false;
                  return {
                    domain: obj.response1.datas.data.result.domainName,
                    status: obj.response1.datas.data.result.domainStatus,
                    price: price,
                    priceRenew: priceRenew,
                    duration: 1,
                    freeWhois: false,
                  };
                }
              }
            } else if (
              domain[0].length === 3 &&
              obj.response1.datas.data.result.tld === "id"
            ) {
              state.premium_price = 16500000;
              state.premium_status = true;
              return {
                domain: obj.response1.datas.data.result.domainName,
                status: obj.response1.datas.data.result.domainStatus,
                price: price,
                priceRenew: priceRenew,
                duration: 1,
              };
            } else if (
              domain[0].length === 4 &&
              obj.response1.datas.data.result.tld === "id"
            ) {
              state.premium_price = 2250000;
              state.premium_status = true;
              return {
                domain: obj.response1.datas.data.result.domainName,
                status: obj.response1.datas.data.result.domainStatus,
                price: price,
                priceRenew: priceRenew,
                duration: 1,
              };
            } else if (obj.response1.datas.data.result.is_premium === 1) {
              state.premium_price = 0;
              state.premium_status = true;
              return {
                domain: obj.response1.datas.data.result.domainName,
                status: obj.response1.datas.data.result.domainStatus,
                price: obj.response1.datas.data.result.price_qw,
                priceRenew: obj.response1.datas.data.result.price_qw,
                duration: 1,
              };
            } else {
              if (response4.autoreg === "irsfanew") {
                state.freeWhois = true;
                state.premium_price = 0;
                state.premium_status = false;
                if (promo_price.type === "Percentage") {
                  let percent = promo_price.price / 100;
                  return {
                    domain: obj.response1.datas.data.result.domainName,
                    status: obj.response1.datas.data.result.domainStatus,
                    price:
                      obj.response1.datas.data.result.tld === "ai"
                        ? obj.response2.data[0].qsetupfee * percent
                        : price * percent,
                    priceRenew:
                      obj.response1.datas.data.result.tld === "ai"
                        ? obj.response3.data[0].qsetupfee
                        : priceRenew,
                    duration:
                      obj.response1.datas.data.result.tld === "ai" ? 2 : 1,
                    freeWhois: true,
                    promocode: obj.promocode,
                    promotype: promo_price.type,
                  };
                } else if (promo_price.type === "Price Override") {
                  return {
                    domain: obj.response1.datas.data.result.domainName,
                    status: obj.response1.datas.data.result.domainStatus,
                    price: promo_price.price,
                    priceRenew:
                      obj.response1.datas.data.result.tld === "ai"
                        ? obj.response3.data[0].qsetupfee
                        : priceRenew,
                    duration:
                      obj.response1.datas.data.result.tld === "ai" ? 2 : 1,
                    freeWhois: true,
                    promocode: obj.promocode,
                    promotype: promo_price.type,
                  };
                } else if (promo_price.type === "Fixed Amount") {
                  return {
                    domain: obj.response1.datas.data.result.domainName,
                    status: obj.response1.datas.data.result.domainStatus,
                    price: promo_price.price,
                    priceRenew:
                      obj.response1.datas.data.result.tld === "ai"
                        ? obj.response3.data[0].qsetupfee
                        : priceRenew,
                    duration:
                      obj.response1.datas.data.result.tld === "ai" ? 2 : 1,
                    freeWhois: true,
                    promocode: obj.promocode,
                    promotype: promo_price.type,
                  };
                }
              } else {
                state.premium_price = 0;
                state.premium_status = false;
                if (promo_price.type === "Percentage") {
                  let percent = promo_price.price / 100;
                  return {
                    domain: obj.response1.datas.data.result.domainName,
                    status: obj.response1.datas.data.result.domainStatus,
                    price:
                      obj.response1.datas.data.result.tld === "ai"
                        ? obj.response2.data[0].qsetupfee * percent
                        : price * percent,
                    priceRenew:
                      obj.response1.datas.data.result.tld === "ai"
                        ? obj.response3.data[0].qsetupfee
                        : priceRenew,
                    duration:
                      obj.response1.datas.data.result.tld === "ai" ? 2 : 1,
                    freeWhois: false,
                    promocode: "ID18DEAL",
                  };
                } else if (promo_price.type === "Price Override") {
                  return {
                    domain: obj.response1.datas.data.result.domainName,
                    status: obj.response1.datas.data.result.domainStatus,
                    price: promo_price.price,
                    priceRenew:
                      obj.response1.datas.data.result.tld === "ai"
                        ? obj.response3.data[0].qsetupfee
                        : priceRenew,
                    duration:
                      obj.response1.datas.data.result.tld === "ai" ? 2 : 1,
                    freeWhois: false,
                    promocode: "ID18DEAL",
                  };
                } else if (promo_price.type === "Fixed Amount") {
                  return {
                    domain: obj.response1.datas.data.result.domainName,
                    status: obj.response1.datas.data.result.domainStatus,
                    price: promo_price.price,
                    priceRenew:
                      obj.response1.datas.data.result.tld === "ai"
                        ? obj.response3.data[0].qsetupfee
                        : priceRenew,
                    duration:
                      obj.response1.datas.data.result.tld === "ai" ? 2 : 1,
                    freeWhois: false,
                    promocode: "ID18DEAL",
                  };
                }
              }
            }
          }
          // Add default return
          return {
            domain: obj.response1.datas.data.result.domainName,
            status: obj.response1.datas.data.result.domainStatus,
            price: price,
            priceRenew: priceRenew,
            duration: obj.response1.datas.data.result.tld === "ai" ? 2 : 1,
            freeWhois: response4.autoreg === "irsfanew"
          };
        });
      })
      .addCase(searchDomainsPromo.rejected, (state, action) => {
        state.status = "error";
        state.error = action.error.message;
      })
      .addCase(getStatusDomain.pending, (state) => {
        state.status = "loading";
        state.backorder_status = "";
      })
      .addCase(getStatusDomain.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.backorder_status = action.payload.response1.status;
        const domainName = action.payload.domain.split(".");
        if (domainName[0].length === 2) {
          if (action.payload.response2.data[0].extension === ".id") {
            state.domain_register = {
              domain: action.payload.domain,
              price: 525000000,
              priceRenew: 525000000,
              duration: 1,
              status: "available",
            };
          } else if (
            action.payload.response2.data[0].extension === ".co.id" ||
            action.payload.response2.data[0].extension === ".web.id" ||
            action.payload.response2.data[0].extension === ".ac.id" ||
            action.payload.response2.data[0].extension === ".my.id" ||
            action.payload.response2.data[0].extension === ".biz.id" ||
            action.payload.response2.data[0].extension === ".or.id" ||
            action.payload.response2.data[0].extension === ".ponpes.id" ||
            action.payload.response2.data[0].extension === ".sch.id"
          ) {
            state.domain_register = {
              domain: action.payload.domain,
              price: 16500000,
              priceRenew: 16500000,
              duration: 1,
              status: "available",
            };
          } else {
            state.domain_register = {
              domain: action.payload.domain,
              price: action.payload.response2.data[0].msetupfee,
              priceRenew: action.payload.response3.data[0].msetupfee,
              duration: 1,
              status: "available",
            };
          }
        } else if (
          domainName[0].length === 3 &&
          action.payload.response2.data[0].extension === ".id"
        ) {
          state.domain_register = {
            domain: action.payload.domain,
            price: 16500000,
            priceRenew: 16500000,
            duration: 1,
            status: "available",
          };
        } else if (
          domainName[0].length === 4 &&
          action.payload.response2.data[0].extension === ".id"
        ) {
          state.domain_register = {
            domain: action.payload.domain,
            price: 2250000,
            priceRenew: 2250000,
            duration: 1,
            status: "available",
          };
        } else {
          state.domain_register = {
            domain: action.payload.domain,
            price: action.payload.response2.data[0].msetupfee,
            priceRenew: action.payload.response3.data[0].msetupfee,
            duration: 1,
            status: "available",
          };
        }
      })
      .addCase(getStatusDomain.rejected, (state, action) => {
        state.status = "error";
        state.error = action.error.message;
      });
  },
});

export const {
  search,
  searchTransfer,
  addEpp,
  backorderStatus,
  handleCLickCheckbox,
  handleSelectDuration,
  saveNameservers,
} = domainSlice.actions;
export default domainSlice.reducer;
